import { ProductsService } from './products';

export async function findAllManufacturers (): Promise<any> {
    return ProductsService.findAllManufacturers();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/products/products.find-all-manufacturers.ts